/* Radiance Veil reviews: filter / sort / show more, photo viewer, and the Write a review form.
   Safety: all text is inserted with textContent; photos are re-drawn on a canvas and re-saved as JPEG before upload
   (drops EXIF/GPS and shrinks them), and the server strips metadata again. Submissions go to the store's own app proxy
   (/apps/rv/review) with a Turnstile check and are saved hidden until the owner approves them. */
(function () {
  var CFG = window.RV_SUPPORT || {};
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function lock(on) { document.documentElement.classList.toggle('rv-modal-open', on); }

  var tsReady = null;
  function turnstileToken(box) {
    tsReady = tsReady || new Promise(function (resolve, reject) {
      if (window.turnstile) return resolve(window.turnstile);
      var s = document.createElement('script'); s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; s.async = true;
      s.onload = function () { resolve(window.turnstile); }; s.onerror = reject; document.head.appendChild(s);
    });
    return tsReady.then(function (ts) {
      return new Promise(function (resolve, reject) {
        box.textContent = '';
        ts.render(box, { sitekey: CFG.turnstileSiteKey, theme: 'light', size: 'flexible', appearance: 'interaction-only',
          callback: resolve, 'error-callback': function () { reject(new Error('verify')); }, 'expired-callback': function () { reject(new Error('verify')); } });
      });
    });
  }

  // Re-draw the photo (browsers apply the camera rotation when drawing) and save a clean JPEG, max 2000px.
  function cleanPhoto(file) {
    return new Promise(function (resolve, reject) {
      if (!/^image\/(jpeg|png|webp)$/.test(file.type)) return reject(new Error('type'));
      if (file.size > 20 * 1024 * 1024) return reject(new Error('size'));
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var max = 2000, w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, max / Math.max(w, h));
        var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
        var g = c.getContext('2d'); g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height); g.drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) { b ? resolve(b) : reject(new Error('encode')); }, 'image/jpeg', 0.86);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('read')); };
      img.src = url;
    });
  }

  // Wipes location / camera / editing metadata from an MP4 or MOV without re-encoding: the 'udta' and 'meta' boxes
  // (and Adobe XMP 'uuid' boxes) are turned into same-size 'free' boxes filled with zeros, so nothing else moves.
  var XMP_UUID = [0xbe, 0x7a, 0xcf, 0xcb, 0x97, 0xa9, 0x42, 0xe8, 0x9c, 0x71, 0x99, 0x94, 0x91, 0xe3, 0xaf, 0xac];
  function wipeVideoMeta(buf) {
    var v = new DataView(buf), u = new Uint8Array(buf), found = false;
    function name(o) { return String.fromCharCode(u[o + 4], u[o + 5], u[o + 6], u[o + 7]); }
    function blank(o, hdr, size) { u[o + 4] = 0x66; u[o + 5] = 0x72; u[o + 6] = 0x65; u[o + 7] = 0x65; u.fill(0, o + hdr, o + size); }
    (function walk(start, end, depth) {
      var o = start;
      while (o + 8 <= end) {
        var size = v.getUint32(o), hdr = 8;
        if (size === 1) { if (o + 16 > end) return; size = v.getUint32(o + 8) * 4294967296 + v.getUint32(o + 12); hdr = 16; }
        else if (size === 0) size = end - o;
        if (size < hdr || o + size > end) return;
        var t = name(o);
        if (t === 'ftyp') found = true;
        if (t === 'udta' || t === 'meta') blank(o, hdr, size);
        else if (t === 'uuid' && XMP_UUID.every(function (b, i) { return u[o + hdr + i] === b; })) blank(o, hdr, size);
        else if (depth < 3 && (t === 'moov' || t === 'trak')) walk(o + hdr, o + size, depth + 1);
        o += size;
      }
    })(0, buf.byteLength, 0);
    return found;
  }
  function cleanVideo(file) {
    if (!/^video\/(mp4|quicktime)$/.test(file.type)) return Promise.reject(new Error('vtype'));
    if (file.size > 100 * 1024 * 1024) return Promise.reject(new Error('vsize'));
    var url = URL.createObjectURL(file);
    return new Promise(function (resolve, reject) {
      var vid = document.createElement('video'); vid.preload = 'metadata'; vid.muted = true;
      // Some browsers can't read every MOV (or pause media loading in a background tab): then only the size limit applies.
      var fallback = setTimeout(function () { URL.revokeObjectURL(url); resolve(); }, 6000);
      vid.onloadedmetadata = function () { clearTimeout(fallback); URL.revokeObjectURL(url); vid.duration > 61 ? reject(new Error('vlong')) : resolve(); };
      vid.onerror = function () { clearTimeout(fallback); URL.revokeObjectURL(url); resolve(); };
      vid.src = url;
    }).then(function () { return file.arrayBuffer(); }).then(function (buf) {
      if (!wipeVideoMeta(buf)) throw new Error('vtype');
      return new Blob([buf], { type: file.type });
    });
  }
  function uploadVideo(blob, slot, onProgress) {
    return new Promise(function (resolve, reject) {
      var fd = new FormData();
      slot.parameters.forEach(function (p) { fd.append(p.name, p.value); });
      fd.append('file', blob);
      var x = new XMLHttpRequest(); x.open('POST', slot.url);
      x.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(Math.round(e.loaded / e.total * 100)); };
      x.onload = function () { x.status >= 200 && x.status < 300 ? resolve() : reject(new Error('upload')); };
      x.onerror = function () { reject(new Error('upload')); };
      x.send(fd);
    });
  }

  function init(root) {
    var list = root.querySelector('[data-rv-list]');
    var perPage = parseInt(root.dataset.perPage, 10) || 5;

    /* ---- Filter / sort / show more ---- */
    if (list) {
      var items = Array.prototype.slice.call(list.querySelectorAll('.rv-review'));
      var fSel = root.querySelector('[data-rv-filter]'), sSel = root.querySelector('[data-rv-sort]');
      var more = root.querySelector('[data-rv-more]'), none = root.querySelector('[data-rv-none]'), shown = perPage;
      var apply = function () {
        var f = fSel.value, s = sSel.value;
        var vis = items.filter(function (a) { return f === 'all' ? true : f === 'photos' ? +a.dataset.photos > 0 : a.dataset.rating === f; });
        vis.sort(function (a, b) {
          if (s === 'newest') return b.dataset.date - a.dataset.date;
          if (s === 'high') return (b.dataset.rating - a.dataset.rating) || (b.dataset.date - a.dataset.date);
          if (s === 'low') return (a.dataset.rating - b.dataset.rating) || (b.dataset.date - a.dataset.date);
          if (s === 'photos') return ((+b.dataset.photos > 0) - (+a.dataset.photos > 0)) || (a.dataset.index - b.dataset.index);
          // Featured (default): pinned reviews first, then newest by the date shown, so editing a date re-sorts right away.
          return (b.dataset.featured - a.dataset.featured) || (b.dataset.date - a.dataset.date) || (a.dataset.index - b.dataset.index);
        });
        items.forEach(function (a) { a.hidden = true; });
        vis.forEach(function (a, i) { list.appendChild(a); a.hidden = i >= shown; });
        more.hidden = vis.length <= shown; none.hidden = vis.length > 0;
        // Filter buttons (All / Photos / 5 ... 1 stars) and the star rows in the band show which filter is on.
        root.querySelectorAll('[data-rv-chip]').forEach(function (c) { c.classList.toggle('is-on', c.dataset.rvChip === f); c.setAttribute('aria-pressed', c.dataset.rvChip === f); });
        root.querySelectorAll('[data-rv-filter-stars]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.rvFilterStars === f); });
      };
      root.querySelectorAll('[data-rv-chip]').forEach(function (c) {
        c.addEventListener('click', function () { fSel.value = c.dataset.rvChip; shown = perPage; apply(); });
      });
      fSel.addEventListener('change', function () { shown = perPage; apply(); });
      sSel.addEventListener('change', function () { shown = perPage; apply(); });
      more.addEventListener('click', function () { shown += perPage; apply(); });
      root.querySelectorAll('[data-rv-filter-stars]').forEach(function (b) {
        b.addEventListener('click', function () {
          // Tapping the row that's already on turns the filter off again.
          fSel.value = fSel.value === b.dataset.rvFilterStars ? 'all' : b.dataset.rvFilterStars; shown = perPage; apply();
          (root.querySelector('.rv-reviews__chips') || fSel).scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      apply();
      // "See my review" links from My Account land on /products/...#review-<handle>: show more until that review is
      // visible, scroll to it and mark it as theirs for a moment.
      var mine = /^#review-[\w-]+$/.test(location.hash) && root.querySelector(location.hash);
      if (mine) {
        while (mine.hidden && shown < items.length) { shown += perPage; apply(); }
        if (mine.hidden) { fSel.value = 'all'; shown = items.length; apply(); }
        mine.classList.add('rv-review--mine');
        setTimeout(function () { mine.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 300);
      }
    }

    /* ---- Photo viewer ---- */
    var viewer = root.querySelector('[data-rv-viewer]');
    if (viewer) {
      var fulls = Array.prototype.slice.call(root.querySelectorAll('template[data-rv-full]'));
      var media = viewer.querySelector('[data-rv-viewer-media]'), cur = 0;
      viewer.dataset.count = fulls.length;
      var showPhoto = function (i) {
        cur = (i + fulls.length) % fulls.length;
        var t = fulls[cur], frag = t.content.cloneNode(true), img = frag.querySelector('img'), p = frag.querySelector('p');
        media.querySelectorAll('video').forEach(function (v) { v.pause(); });
        media.textContent = ''; var vid = frag.querySelector('video');
        if (vid) { vid.setAttribute('playsinline', ''); media.appendChild(vid); } else if (img) media.appendChild(img);
        viewer.querySelector('[data-rv-viewer-author]').textContent = t.dataset.author || '';
            viewer.querySelector('[data-rv-viewer-text]').textContent = p && p.textContent !== '(No written review)' ? p.textContent : '';
        viewer.querySelector('[data-rv-viewer-stars] .rv-stars__fill').style.width = (+t.dataset.rating * 20) + '%';
        viewer.querySelector('[data-rv-viewer-count]').textContent = (cur + 1) + ' / ' + fulls.length;
      };
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-rv-photo]'); if (!b || !fulls.length) return;
        showPhoto(+b.dataset.rvPhoto); viewer.showModal(); lock(true);
      });
      viewer.querySelector('[data-rv-viewer-close]').addEventListener('click', function () { viewer.close(); });
      viewer.querySelector('[data-rv-viewer-prev]').addEventListener('click', function () { showPhoto(cur - 1); });
      viewer.querySelector('[data-rv-viewer-next]').addEventListener('click', function () { showPhoto(cur + 1); });
      viewer.addEventListener('close', function () { media.querySelectorAll('video').forEach(function (v) { v.pause(); }); lock(false); });
      viewer.addEventListener('click', function (e) { if (e.target === viewer || e.target.classList.contains('rv-viewer__stage')) viewer.close(); });
      viewer.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') showPhoto(cur - 1); if (e.key === 'ArrowRight') showPhoto(cur + 1); });
      var x0 = null;
      viewer.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      viewer.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) showPhoto(cur + (dx < 0 ? 1 : -1)); x0 = null; });
    }

    /* ---- Write a review ---- */
    var dlg = root.querySelector('[data-rv-rform]');
    if (!dlg) return;
    var form = dlg.querySelector('[data-rv-rform-form]'), done = dlg.querySelector('[data-rv-rform-done]');
    var err = dlg.querySelector('[data-rv-rform-error]'), btn = dlg.querySelector('[data-rv-rform-submit]'), tsBox = dlg.querySelector('[data-rv-rform-ts]');
    var fileIn = dlg.querySelector('[data-rv-rform-files]'), previews = dlg.querySelector('[data-rv-rform-previews]'), photos = [], video = null;
    var showErr = function (t) { err.textContent = t; err.hidden = !t; if (t) err.scrollIntoView({ block: 'nearest' }); };
    root.querySelectorAll('[data-rv-review-write]').forEach(function (b) {
      b.addEventListener('click', function () { form.hidden = false; done.hidden = true; showErr(''); dlg.showModal(); lock(true); });
    });
    dlg.querySelectorAll('[data-rv-rform-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
    dlg.addEventListener('close', function () { lock(false); });
    var removeBtn = function (label, onRemove) {
      var x = el('button', null, '×'); x.type = 'button'; x.setAttribute('aria-label', label); x.addEventListener('click', onRemove); return x;
    };
    var drawPreviews = function () {
      previews.textContent = '';
      photos.forEach(function (p, i) {
        var li = el('li'), im = el('img'); im.src = p.url; im.alt = 'Photo ' + (i + 1); li.appendChild(im);
        li.appendChild(removeBtn('Remove photo ' + (i + 1), function () { URL.revokeObjectURL(p.url); photos.splice(i, 1); drawPreviews(); }));
        previews.appendChild(li);
      });
      if (video) {
        var li = el('li', 'is-video'), v = el('video'); v.src = video.url + '#t=0.1'; v.muted = true; v.playsInline = true; v.preload = 'metadata'; li.appendChild(v);
        li.appendChild(removeBtn('Remove video', function () { URL.revokeObjectURL(video.url); video = null; drawPreviews(); }));
        previews.appendChild(li);
      }
    };
    var VIDEO_ERR = { vtype: 'Please choose an MP4 or iPhone (MOV) video.', vsize: 'Videos can be up to 100 MB.', vlong: 'Videos can be up to 60 seconds long.' };
    fileIn.addEventListener('change', function () {
      var files = Array.prototype.slice.call(fileIn.files || []); fileIn.value = ''; showErr('');
      var imgs = files.filter(function (f) { return /^image\//.test(f.type); }), vids = files.filter(function (f) { return /^video\//.test(f.type); });
      imgs.slice(0, Math.max(0, 3 - photos.length)).forEach(function (f) {
        cleanPhoto(f).then(function (blob) { if (photos.length < 3) { photos.push({ blob: blob, url: URL.createObjectURL(blob) }); drawPreviews(); } })
          .catch(function () { showErr('One of those photos couldn\'t be added. Please use a JPG or PNG under 20 MB.'); });
      });
      if (imgs.length + photos.length > 3) showErr('You can add up to 3 photos.');
      if (vids.length) {
        if (video || vids.length > 1) showErr('You can add 1 video.');
        if (!video) cleanVideo(vids[0]).then(function (blob) { video = { blob: blob, type: vids[0].type, url: URL.createObjectURL(blob) }; drawPreviews(); })
          .catch(function (e) { showErr(VIDEO_ERR[e.message] || 'That video couldn\'t be added. Please try a different one.'); });
      }
    });

    var api = (CFG.endpoint || '/apps/rv');
    form.addEventListener('submit', function (e) {
      e.preventDefault(); showErr('');
      var fd = new FormData(form), rating = fd.get('rating');
      if (!rating) return showErr('Please choose a star rating.');
      if (String(fd.get('body') || '').trim().length < 2) return showErr('Please write a short review.');
      if (!String(fd.get('author') || '').trim()) return showErr('Please add the name you\'d like shown.');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(fd.get('email') || '').trim())) return showErr('Please enter a valid email.');
      btn.disabled = true; btn.textContent = 'Sending…';
      // 1. Video (if any): get a one-time upload slot, then upload straight to Shopify's video storage.
      var step = !video ? Promise.resolve(null) : turnstileToken(tsBox).then(function (token) {
        return fetch(api + '/review/video-target', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ size: video.blob.size, type: video.type, ts: token }) }).then(function (r) { return r.json(); });
      }).then(function (slot) {
        if (!slot || !slot.ok) throw { reason: (slot && slot.reason) || 'video' };
        return uploadVideo(video.blob, slot, function (pct) { btn.textContent = 'Uploading video ' + pct + '%'; })
          .then(function () { btn.textContent = 'Sending…'; return slot.resourceUrl; });
      });
      // 2. The review itself (photos ride along; they're small).
      step.then(function (videoUrl) {
        return turnstileToken(tsBox).then(function (token) {
          var out = new FormData();
          ['rating', 'title', 'body', 'fit', 'size', 'height', 'author', 'email', 'order'].forEach(function (k) { var v = fd.get(k); if (v != null) out.append(k, String(v).trim()); });
          out.append('product_id', root.dataset.productId); out.append('ts', token);
          if (videoUrl) out.append('video', videoUrl);
          photos.forEach(function (p, i) { out.append('photo' + i, p.blob, 'photo' + i + '.jpg'); });
          return fetch(api + '/review', { method: 'POST', body: out, credentials: 'same-origin' });
        });
      }).then(function (r) { return r.json().catch(function () { return { ok: false }; }); }).then(function (res) {
        if (!res.ok) throw res;
        form.hidden = true; done.hidden = false; form.reset();
        photos.forEach(function (p) { URL.revokeObjectURL(p.url); }); photos = [];
        if (video) URL.revokeObjectURL(video.url);
        video = null; drawPreviews();
      }).catch(function (res) {
        var r = res && res.reason, m = res instanceof Error ? res.message : '';
        showErr(r === 'slow_down' ? 'Too many attempts in a short time. Please wait a moment and try again.'
          : r === 'verify' || m === 'verify' ? 'We couldn\'t verify your submission. Please try again.'
          : r === 'links' ? 'Please remove links from your review.'
          : r === 'photo' ? 'One of your photos couldn\'t be uploaded. Try a different photo.'
          : r === 'video' || m === 'upload' ? 'Your video couldn\'t be uploaded. Try a shorter or smaller video.'
          : r === 'invalid' ? 'Please check the form and try again.'
          : 'Something went wrong on our end. Please try again, or reach us at ' + (CFG.email || 'support@radianceveil.com') + '.');
      }).then(function () { btn.disabled = false; btn.textContent = 'Submit review'; tsBox.textContent = ''; });
    });
  }
  // Desktop arrows on the review photo strip: scroll about one screen of photos; each arrow hides at its end
  document.querySelectorAll('.rv-reviews__gallery').forEach(function (g) {
    var strip = g.querySelector('.rv-reviews__strip'), btns = g.querySelectorAll('[data-rv-strip-nav]');
    if (!strip || btns.length < 2) return;
    function sync() {
      var max = strip.scrollWidth - strip.clientWidth;
      btns[0].hidden = strip.scrollLeft <= 2;
      btns[1].hidden = strip.scrollLeft >= max - 2;
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { strip.scrollBy({ left: Number(b.dataset.rvStripNav) * strip.clientWidth * 0.8, behavior: 'smooth' }); });
    });
    strip.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
  document.querySelectorAll('[data-rv-reviews]').forEach(init);
})();
